const host = {
    "dn":"demo.bubble-in.com",
    "broker_id":10
}
export default host
